import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import { AppState } from "../store/app_state";

import { AuthState } from "src/presentation/store/auth_state";
import { createAppNotificationMessageActionCreator } from "../action/app_notification_message_action";
import { createClientMessageRoomActionCreator } from "../action/client_message_room_action";
import { createClientMessageRoomsActionCreator } from "../action/client_message_rooms_action";
import ClientMessageRoomsComponent from "../component/client/message_rooms/client_message_rooms";
import {
  createAppNotificationMessageDispatcher,
  IAppNotificationMessageDispatcher,
} from "../dispatcher/app_notification_message_dispatcher";
import {
  createClientMessageRoomDispatcher,
  IClientMessageRoomDispatcher,
} from "../dispatcher/client_message_room_dispatcher";
import {
  createClientMessageRoomsDispatcher,
  IClientMessageRoomsDispatcher,
} from "../dispatcher/client_message_rooms_dispatcher";
import { ClientMessageRoomState } from "../store/client_message_room_state";
import { ClientMessageRoomsState } from "../store/client_message_rooms_state";

interface IProps {
  messageRoomsState: ClientMessageRoomsState;
  messageRoomState: ClientMessageRoomState;
  messageRoomsDispatcher: IClientMessageRoomsDispatcher;
  messageRoomDispatcher: IClientMessageRoomDispatcher;
  notificationDispatcher: IAppNotificationMessageDispatcher;
  history: any;
  match: any;
  authState: AuthState;
}

interface IState {
  isInit: boolean;
}

export class ClientMessageRooms extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    this.props.messageRoomsDispatcher.startPollingMessageRooms();
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.messageRoomsState.isLoading &&
      prevProps.messageRoomsState.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public componentWillUnmount() {
    this.props.messageRoomsDispatcher.stopPollingMessageRooms();
  }

  public render(): JSX.Element {
    const {
      messageRoomsState,
      messageRoomState,
      messageRoomDispatcher,
      messageRoomsDispatcher,
      notificationDispatcher,
      match,
      authState,
    } = this.props;
    const { isInit } = this.state;

    if (
      authState.company === null ||
      authState.user === null ||
      authState.user.client === null
    ) {
      return <></>;
    }

    return (
      <ClientMessageRoomsComponent
        messageRoomState={messageRoomState}
        messageRoomsState={messageRoomsState}
        messageRoomDispatcher={messageRoomDispatcher}
        messageRoomsDispatcher={messageRoomsDispatcher}
        notificationDispatcher={notificationDispatcher}
        contracts={messageRoomsState.contracts}
        isInit={isInit}
        match={match}
        company={authState.company!}
        client={authState.user!.client!}
      />
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    messageRoomsState: state.clientMessageRoomsReducer,
    messageRoomState: state.clientMessageRoomReducer,
    authState: state.authReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    messageRoomsDispatcher: createClientMessageRoomsDispatcher(
      dispatch,
      createClientMessageRoomsActionCreator()
    ),
    messageRoomDispatcher: createClientMessageRoomDispatcher(
      dispatch,
      createClientMessageRoomActionCreator()
    ),
    notificationDispatcher: createAppNotificationMessageDispatcher(
      dispatch,
      createAppNotificationMessageActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientMessageRooms);



// WEBPACK FOOTER //
// ./src/presentation/container/client_message_rooms_container.tsx